import React from "react"
import { useTranslation } from "react-i18next"

import { ButtonProps } from "shared/ui/buttons/Button"
import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

import {
  ProductConfigurator,
  ProductConfiguratorModel
} from "widgets/product-configurator/ProductConfigurator"

export interface ProductConfigurationOverlayViewModel {
  isSubmitDisabled: boolean
  scrollOnTabChange: boolean
  headline: string
  productConfiguratorModel: ProductConfiguratorModel
  closeOverlay: () => void

  previousButtonProps: ButtonProps
}

export const ProductConfigurationOverlayView = React.memo(
  ({
    headline,
    scrollOnTabChange,
    productConfiguratorModel,
    previousButtonProps,
    closeOverlay
  }: ProductConfigurationOverlayViewModel) => {
    const { t } = useTranslation()
    return (
      <OverlayWrapper
        id="product-configuration-overlay"
        className="product-configuration-overlay"
        classNamePrefix="product-configuration-overlay"
        headline={headline}
        mobileFullscreen
      >
        <OverlayHeader.Container prefix="product-configuration-overlay">
          <OverlayHeader.CloseButton
            onClick={closeOverlay}
            className="primary"
          />
          <OverlayHeader.Title>{headline}</OverlayHeader.Title>
          <OverlayHeader.Action
            data-testid="product-configurator--previous-step-button"
            label={t("General.Previous")}
            {...previousButtonProps}
            className="secondary"
          />
        </OverlayHeader.Container>
        <ProductConfigurator
          className="product-configuration-overlay__configurator"
          hideTitle
          scrollOnTabChange={scrollOnTabChange}
          hideFallbackBackupVariantKeyInput
          {...productConfiguratorModel}
        />
      </OverlayWrapper>
    )
  }
)
